import { render, staticRenderFns } from "./JogadoresPesquisa.vue?vue&type=template&id=6c947a52&"
import script from "./JogadoresPesquisa.vue?vue&type=script&lang=js&"
export * from "./JogadoresPesquisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports